/* @flow */
import React from 'react';
// $FlowIgnore
import { MdFileUpload } from 'react-icons/md';

export default function UploadIcon({
  style
}: Object): React.Element {
  return <MdFileUpload style={style} />;
}
